import React, { ErrorInfo } from 'react';
import ReactDOMClient from 'react-dom/client';
import { AppProps } from 'single-spa';
import singleSpaReact from 'single-spa-react';
import { setupLandrDevTools, ApplicationEnum } from '@landr/core';
import { ErrorBoundaryState } from 'error/components/ErrorBoundary/ErrorBoundary';
import { log } from 'utils/log';
import { DeviceType } from '@landr/react-core';
import { APP_VERSION, EventIds } from './constants';
import { CONFIG } from './utils/config';
import { RootProviders } from './providers';

import './index.css';

function domElementGetter() {
    const el = document.getElementById('app-content');

    if (!el) {
        throw new Error('samples-mfe container element not found');
    }

    return el;
}

export class Root extends React.Component<
    AppProps & {
        basename: string;
        deviceType: DeviceType;
        isExtendableHeight?: boolean;
        isFooterAllowed?: boolean;
    },
    ErrorBoundaryState
> {
    componentDidCatch(error: Error, info: ErrorInfo) {
        log.fatal(
            'Root component unhandled error. This should never happen',
            EventIds.RootComponentUnhandledError,
            error,
            info,
        );
    }

    render() {
        return (
            <RootProviders
                basename={this.props.basename}
                deviceType={this.props.deviceType}
                isExtendableHeight={this.props?.isExtendableHeight ?? false}
                isFooterAllowed={this.props?.isFooterAllowed ?? false}
            />
        );
    }
}
const reactLifecycles = singleSpaReact({
    React: React as any,
    ReactDOMClient,
    rootComponent: Root,
    domElementGetter,
});

// eslint-disable-next-line  @typescript-eslint/ban-ts-comment
// @ts-ignore
export const { mount, unmount, unload, bootstrap } = reactLifecycles;

setupLandrDevTools(ApplicationEnum.SamplesMarketplace, APP_VERSION, CONFIG);
